// removed by extract-text-webpack-plugin
module.exports = {"lineTotal":"lineTotal","hkchart":"hkchart","lineTitle":"lineTitle","lineAxi":"lineAxi","linesubTitle":"linesubTitle"};